import {makePostBeneficiaryToken} from 'main/factories/usecases/private/beneficiary-token';
import {PostBeneficiaryTokenParams} from 'domain/usecases';

export async function postToken(params: PostBeneficiaryTokenParams) {
	const response = await makePostBeneficiaryToken().post(params);

	return response;
}
